import { createContext } from 'react';
import { signalRService } from '@/services/signalr';

export const SignalRContext = createContext(signalRService);
